import ImageToolbarView from "./ImageToolbarView.vue";
import ImageNode from "./ImageNode";
import {isActive} from "@tiptap/vue-3";
import ImageBubbleView from "./ImageBubbleView.vue";

export default class Image {

    constructor() {
        this.toolbarView = ImageToolbarView;
        this.bubbleView = ImageBubbleView;
    }

    showBubble(props) {
        return isActive(props.state, "image");
    }

    static create(endpoint, method) {
        return new Image(endpoint, method);
    }

    uploads(endpoint, method, extensions) {
        this.config = {
            endpoint: endpoint,
            method: method,
            extensions: extensions
        }
        return this;
    }

    getExtensions() {
        return [ImageNode];
    }
}